export const defaultContactAdditionalState = {
	ContactAdditionalData: [],
	Total: 0
};

export default {
	...defaultContactAdditionalState
};
